import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffPositionCatalogRequest,
  StaffPositionCatalogResponse,
} from "../model/position.model";

@Injectable({ providedIn: "root" })
export class StaffPositionsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/job-positions`;
  }

  list(departmentId?: number): Observable<StaffPositionCatalogResponse[]> {
    const params = departmentId == null
      ? undefined
      : new HttpParams().set("departmentId", departmentId);
    return this.http.get<StaffPositionCatalogResponse[]>(this.url, { params });
  }

  getById(id: number): Observable<StaffPositionCatalogResponse> {
    return this.http.get<StaffPositionCatalogResponse>(`${this.url}/${id}`);
  }

  create(
    request: StaffPositionCatalogRequest,
  ): Observable<StaffPositionCatalogResponse> {
    return this.http.post<StaffPositionCatalogResponse>(this.url, request);
  }

  update(
    id: number,
    request: StaffPositionCatalogRequest,
  ): Observable<StaffPositionCatalogResponse> {
    return this.http.put<StaffPositionCatalogResponse>(
      `${this.url}/${id}`,
      request,
    );
  }

  setStatus(
    id: number,
    active: boolean,
  ): Observable<StaffPositionCatalogResponse> {
    return this.getById(id).pipe(
      switchMap(position => {
        return this.update(id, {
          departmentId: position.departmentId,
          name: position.name,
          active: active
        });
      })
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
